export default __webpack_public_path__ + "static/4.3mm_IRcut-de74e6dae8cb731bda17923f04ecc4b5.webp";